var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-2",attrs:{"block":"","disabled":_vm.disabled,"loading":_vm.loading,"color":"primary","small":""},on:{"click":_vm.onsubmit}},[_vm._v(" Convertir a usuario "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-account-reactivate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }